/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2021-08-30 10:35:05
 * @LastEditors: Ali2vu
 * @LastEditTime: 2021-08-30 10:35:05
 */

import * as request from '@/utils/request'
const BASE_URL = 'paas'
export default {
  /**
   * getWarnList
   * @description 预警记录列表
   * @author LZP
   * @date 2021-08-30
   * @param {*} data
   * @returns
   */
  getWarnList(data) {
    return request.get(`/${BASE_URL}/tradePayOffSum/list`, data)
  },
  /**
   * getWarnList
   * @description 预警数量获取
   * @author LZP
   * @date 2021-08-30
   * @param {*} data
   * @returns
   */
  getWarnNum() {
	// return request.post(`/${BASE_URL}/customer/list`,{page_size:10,current_page:1})
	return request.get(`/${BASE_URL}/tradePayOffSum/list`,{page_size:10,current_page:1,tenant_id:"289707619174600704"})
  },
  /**
   * getWarnStatistics
   * @description 预警统计数据获取
   * @author LZP
   * @date 2021-08-31
   * @param {*} data
   * @returns
   */
  getWarnStatistics(data) {
	return request.get(`/${BASE_URL}/tradePayOffSum/chart`,data)
  },
  /**
   * getWarnListData
   * @description 预警记录列表
   * @author LZP
   * @date 2021-08-30
   * @param {*} data
   * @returns
   */
  getWarnListData(data){
	return request.get(`/${BASE_URL}/early_warning/warning`,data)
  }
}